(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2026-marathon-expo-terms"] && !Shopify.designMode) return;
  try {
    
// 可以添加交互逻辑，如果需要的话

  } catch(e) { console.error(e); }
})();
})();
